import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { homeContent } from '@/mocks/content';

export default function BlogSection() {
  const blogArticles = articles.slice(0, 10);

  return (
    <section id="blog" className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-xs font-semibold text-secondary-700 uppercase tracking-wider mb-4">
            {homeContent.articleSectionTag}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            {homeContent.articleSectionTitle}
          </h2>
          <p className="text-base md:text-lg text-foreground-500">
            {homeContent.articleSectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-left group block rounded-2xl bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer overflow-hidden"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2.5">
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime} чтения</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-accent-600 group-hover:text-accent-700 whitespace-nowrap">
                  Читать
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}